import { Component } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { LayoutService } from '../../service/app.layout.service';

@Component({
  standalone: false,
  selector: 'app-menu-company-orga',
  templateUrl: './menu-company-orga.component.html',
  styleUrl: './menu-company-orga.component.scss'
})
export class MenuCompanyOrgaComponent {
  dashboardItems: any[] = [];
  adminItems: any[] = [];
  organisationItems: any[] = [];
  inputItems: any[] = [];
  outputItems: any[] = [];
  searchItems: any[] = [];

  documentsCount: any;
  documentsDone: any;
  documentsProcessing: any;
  tags: any;
  taxonomies: any;
  dates: any;
  users: any;
  companies: any;
  currentUser: any;

  currentCompany: any;

  isLoading: boolean = false;

  constructor(
    public layoutService: LayoutService,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    this.setMenu();



    this.currentUser = this.apiService.currentUser;
    if (!this.currentUser) {
      this.apiService.currentUserChange.subscribe((user) => {
        this.currentUser = user;
        this.currentCompany = localStorage.getItem('currentCompany') ? JSON.parse(localStorage.getItem('currentCompany')) : null;

        this.setMenu();
        this.isLoading = false;
      });
    }

    this.documentsCount = this.apiService.documentsCount;
    if (this.documentsCount) {
      this.documentsDone = this.documentsCount.done;
      this.documentsProcessing = this.documentsCount.processing;
    }
    this.apiService.documentsChanges.subscribe((data) => {
      this.documentsCount = data;
      if (this.documentsCount) {
        this.documentsDone = this.documentsCount.done;
        this.documentsProcessing = this.documentsCount.processing;
      } else {
        this.documentsDone = 0;
        this.documentsProcessing = 0;
      }

      this.inputItems[0].items.find(item => item.label == 'Importer un document').badge = this.documentsProcessing;
      this.searchItems[0].items.find(item => item.label == 'Documents').badge = this.documentsDone;
    });

    this.currentCompany = this.apiService.currentCompany;
    this.apiService.currentCompanyChange.subscribe((data) => {
      this.currentCompany = data;
    })


  }


  setMenu() {


    if (localStorage.getItem('isSupervisor') == "true" && !localStorage.getItem('currentCompany') && localStorage.getItem('isSuperAdmin') != "1") {
      return;
    }


    if (this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isAdmin') == "true" || localStorage.getItem('isSupervisor') == 'true')) {
      this.adminItems = [
        {
          label: 'Administration',
          items: [
            {
              label: 'Consommation',
              icon: 'pi pi-fw pi-sliders-v',
              routerLink: ['/admin/usage'],
              visible: this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isAdmin') == "true" || localStorage.getItem('isSupervisor') == 'true') ? true : false,
            },
            {
              label: 'Réglages',
              icon: 'pi pi-fw pi-cog',
              routerLink: ['/admin/settings'],
              visible: this.currentUser && (this.currentUser.is_superadmin || localStorage.getItem('isAdmin') == "true" || localStorage.getItem('isSupervisor') == 'true') ? true : false,
            },
          ],
        },
      ];
    }



    this.inputItems = [
      {
        label: 'Input',
        items: [
          {
            label: 'Importer un document',
            icon: 'pi pi-fw pi-download',
            hasBadge: true,
            badge: this.documentsProcessing ? this.documentsProcessing.length : 0,
            routerLink: ['/pages/import'],
          },
          {
            label: 'Import Zendesk',
            icon: 'pi pi-fw pi-download',
            hasBadge: true,
            badge: this.documentsProcessing ? this.documentsProcessing.length : 0,
            routerLink: ['/pages/import-zendesk'],
            visible: (this.currentUser && this.currentUser.is_superadmin) ? true : false,
          },
          {
            label: 'Import Wordpress',
            icon: 'pi pi-fw pi-download',
            hasBadge: true,
            badge: this.documentsProcessing ? this.documentsProcessing.length : 0,
            routerLink: ['/pages/import-wp'],
            visible: (this.currentUser && this.currentUser.is_superadmin) ? true : false,
          },
        ],
      },
    ];

    this.outputItems = [
      {
        label: 'Output',
        items: [
          {
            label: 'Poser une question',
            icon: 'pi pi-fw pi-comments',
            routerLink: ['/pages/chat'],
          },
          {
            label: 'Actions',
            icon: 'pi pi-fw pi-bolt',
            routerLink: ['/pages/actions'],
            visible: (this.currentUser && this.currentUser.is_superadmin) ? true : false,
          },
          {
            label: 'Agents',
            icon: 'pi pi-fw pi-users',
            routerLink: ['/pages/agents'],
            visible: (this.currentUser && this.currentUser.is_superadmin) ? true : false,
          },
          {
            label: 'Bibliothèque de prompts',
            icon: 'pi pi-fw pi-book',
            routerLink: ['/pages/prompts'],
            visible: (this.currentUser && this.currentUser.is_superadmin) ? true : false,
          },
          {
            label: 'Bibliothèque d\'instructions',
            icon: 'pi pi-fw pi-book',
            routerLink: ['/pages/instructions'],
            visible: (this.currentUser && this.currentUser.is_superadmin) ? true : false,
          },
          {
            label: 'Historique des conversations',
            icon: 'pi pi-fw pi-history',
            routerLink: ['/pages/conversations']
          },
          {
            label: 'Documents générés',
            icon: 'pi pi-fw pi-file-export',
            routerLink: ['/pages/generated-documents']
          },
          {
            label: 'Carte',
            icon: 'pi pi-fw pi-map',
            routerLink: ['/pages/map'],
            visible: (this.currentUser && this.currentUser.is_superadmin) ? true : false,
          },
        ],
      },
    ];

    this.searchItems = [
      {
        label: 'Votre Narrathèque',
        items: [
          {
            label: 'Documents',
            icon: 'pi pi-fw pi-file',
            hasBadge: true,
            badge: this.documentsDone ? this.documentsDone.length : 0,
            routerLink: ['/pages/documents'],
          },
          {
            label: 'Tags',
            icon: 'pi pi-fw pi-tag',
            routerLink: ['/pages/tags'],
          },
          {
            label: 'Catégories',
            icon: 'pi pi-fw pi-inbox',
            routerLink: ['/pages/taxonomies'],
          },
          {
            label: 'Dates',
            icon: 'pi pi-fw pi-calendar',
            routerLink: ['/pages/dates'],
            visible: (this.currentUser && this.currentUser.is_superadmin) ? true : false,
          },
          {
            label: 'Rechercher un document',
            icon: 'pi pi-fw pi-search',
            routerLink: ['/pages/search'],
            visible: (this.currentUser && this.currentUser.is_superadmin) ? true : false,
          },
        ],
      },
    ];
  }
}
